import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { FlexRowDiv, Box, H1, P, A } from 'components/generic/HomePageComponents'
import { paras, bulletPoints, articlesJobs, links } from 'lib/CLData'

// TODO: Probably should clean up this code.
const CCAButton = styled(A)`
  background-color: ${(props) => props.theme.colors.inverseColor};
  transition: background-color 0.5s ease;
  width: 400px;
  padding: 10px 48px;
  font-weight: bold;
  white-space: normal;
  font-size: ${(props) => props.theme.buttonTextSize};
  margin-top: 35px;
  border: 2px #fff solid;
  text-decoration: none;
  color: ${(props) => props.theme.buttonColor};
  border-radius: 5px;
  text-align: center;
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.inverseColor};
    border-color: ${(props) => props.theme.colors.inverseColor};
  }
`

const TableP = (props) => <P {...props} />

const MyA = styled(TableP)`
  text-decoration: none;
  color: ${(props) => props.theme.colors.inverseColor};
  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
  padding-left: 15px;
  margin-bottom: 15px;
`
const InlineA = styled(A)`
  text-decoration: none;
  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`
const MyP = (props) => <P maxWidth='100%' {...props} />
const MainRow = (props) => (
  <FlexRowDiv pt='100px' {...props} pb='100px'>
    <FlexRowDiv
      flexDirection={['column', 'column', 'row']}
      justifyContent='space-around'
      maxWidth='1259px'
      width='100%'
      ml={['10px', '20px', '20px']}
      mr={['10px', '20px', '20px']}
    >
      {props.children}
    </FlexRowDiv>
  </FlexRowDiv>
)

const Paras = () =>
  paras &&
  paras.length > 0 &&
  paras.map(({ header, para, image }) => (
    <>
      <H1 fontSize='35px' mb='15px' lineHeight='35px'>
        {header}
      </H1>
      <MyP>{para}</MyP>
      {image ? <LazyLoadImage src={image} /> : null}
    </>
  ))
const ColumnOne = (props) => (
  <FlexRowDiv
    {...props}
    flexDirection='column'
    width={['90%', '100%', '100%']}
    justifyContent='flex-start'
    pr='30px'
    ml='10px'
    mr='10px'
  >
    <Paras />
    <ul>
      <MakeBullets />
    </ul>
    <Box borderRadius='5px' bg='#f5f5f5'>
      <P width='100%' maxWidth='100%' textAlign='center'>
        <span>
          {' '}
          <InlineA href='https://housekeeper.com' color='#725090'>
            Housekeeper.com
          </InlineA>
        </span>
        . Are you looking for cleaning lady services? Find{' '}
        <span>
          <InlineA href='https://housekeeper.com' color='#725090'>
            housekeepers
          </InlineA>
        </span>
        now!
      </P>
    </Box>
  </FlexRowDiv>
)

const DarkDiv = (props) => (
  <FlexRowDiv
    flexDirection='column'
    bg='#f5f5f5'
    pt='20px'
    mt='20px'
    width={['100%', '100%', '100%']}
    borderRadius='10px'
    border='1px rgb(234, 217, 217) solid'
  >
    {props.children}
  </FlexRowDiv>
)
const DarkHeader = (props) => <P pl='20px' fontSize='24px' fontWeight='700' {...props} />
const ColumnTwo = (props) => (
  <FlexRowDiv
    flexDirection='column'
    justifyContent='center'
    alignItems='center'
    width={['90%', '100%', '50%']}
    ml='10px'
    mr='10px'
  >
    <CCAButton href='https://housekeeper.com/jobs' bg='blue'>
      Housekeepers on Housekeeper.com
    </CCAButton>

    <DarkDiv>
      <DarkHeader>Cleaning Lady Jobs</DarkHeader>
      <MakeRows links={articlesJobs} />
      <DarkHeader>Cleaning Lady Services</DarkHeader>
      <MakeRows links={articlesJobs} />
    </DarkDiv>

    <DarkDiv>
      <DarkHeader>Housekeepers</DarkHeader>
      <MakeRows links={links} />
    </DarkDiv>
  </FlexRowDiv>
)

const MakeRows = ({ links }) =>
  links &&
  links.length > 0 &&
  links.map(({ title, link }, index) => (
    <MyA
      fontSize='14px'
      as='a'
      paddingLeft='15px'
      mb='15px'
      href={link}
      title={title}
      pl='20px'
      key={index}
    >
      {title}
    </MyA>
  ))

const MakeBullets = () =>
  bulletPoints &&
  bulletPoints.length > 0 &&
  bulletPoints.map((point, index) => (
    <P key={index} as='li' maxWidth='100%' pb='20px'>
      {point}
    </P>
  ))

const CleaningLady = () => (
  <MainRow>
    <ColumnOne />
    <ColumnTwo />
  </MainRow>
)
export default CleaningLady
